import React from "react";
import { Badge } from "@120wateraudit/waterworks";
import { Popup } from "semantic-ui-react";
import { ExportStatus } from "src/services/export-service-api";

interface ExportStatusBadgeProps {
  status: ExportStatus;
  errors: string[];
  style?: React.CSSProperties;
}

const getExportStatusColor = (status: ExportStatus): string => {
  const failed = "#F7685B";
  const processing = "#FFC107";
  const completed = "#16A34A";

  if (status === ExportStatus.Failed) {
    return failed;
  } else if (status === ExportStatus.GatheringData) {
    return processing;
  } else if (status === ExportStatus.Completed) {
    return completed;
  }
  return "#FFFFFF";
};

export const ExportStatusBadge: React.FC<ExportStatusBadgeProps> = ({
  status,
  errors,
  style,
}) => {
  const errorsList = errors?.map((error: string, index: number) => (
    <p key={index}>{error}</p>
  ));
  const statusColor = getExportStatusColor(status);
  const errorDialogContent = <div>{errorsList}</div>;
  const badge = (
    <Badge
      style={{
        ...style,
        justifyContent: "center",
        textAlign: "center",
        minWidth: "80px",
        color: "#FFFFFF",
      }}
      backgroundColor={statusColor}
    >
      {status.replace(/([a-z])([A-Z])/g, '$1 $2')}
    </Badge>
  );

  return status === ExportStatus.Failed
  ? (
    <Popup
      trigger={<div>{badge}</div>}
      content={errorDialogContent}
      position="top center"
    />
  )
  : (
    <div>{badge}</div>
  );
};

export default ExportStatusBadge;
